import { Box, Typography, styled, darken, lighten } from '@mui/material';
import { isDarkMode } from '@localstack/services';

export const MainContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexDirection: 'column',
  position: 'fixed',
  inset: 0,
  background: isDarkMode(theme)
    ? darken(theme.palette.background.default, 0.6)
    : lighten(theme.palette.background.default, 0.03),
}));

export const ContentContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  maxWidth: '32rem',
}));

export const LogoContainer = styled(Box)(() => ({
  marginBottom: '2.5rem',
}));

export const InstructionsContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '1rem',
  maxWidth: 'inherit',
}));

export const SubText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '1.25rem',
}));

export const FooterContainer = styled(Box)(() => ({
  position: 'absolute',
  bottom: '2rem',
  left: '50%',
  transform: 'translateX(-50%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  gap: '0.5rem',
}));

export const EmailText = styled(Typography)(({ theme }) => ({
  color: theme.palette.text.secondary,
  fontSize: '0.875rem',
}));
